<template>
  <div class="infoBody">
    <v-avatar
        class="lightGray"
        size="80"
    >
      <span class="initials">{{ lastName.slice(0,1) }}{{ firstName.slice(0,1) }}</span>
    </v-avatar>
    <div>
      <div class="userName">{{ lastName }} {{ firstName }} {{ middleName }}</div>
      <div v-if="userRole" class="userRole">{{userRole}}</div>
      <div v-if="organizationName" class="userOrg">{{ organizationName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  props: {
    firstName: {
      type: String,
      required: true,
    },
    middleName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    userRole: {
      type: String,
    },
    organizationName: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.infoBody {
  display: flex;
  column-gap: 10px;
}

.lightGray {
  background-color: rgb(var(--avatar-color));
}

.initials {
  color: rgb(var(--gold-color));
  font-size: 23px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.userName {
  color: rgb(var(--gold-color));
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 27px;
}

.userOrg {
  color: rgb(var(--gold-color));
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.userRole {
  color: rgb(var(--gold-color));
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
}
</style>